import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M960 1920C429.807 1920 0 1490.193 0 960S429.807 0 960 0s960 429.807 960 960-429.807 960-960 960zm0-101.053c474.384 0 858.947-384.563 858.947-858.947S1434.384 101.053 960 101.053 101.053 485.616 101.053 960 485.616 1818.947 960 1818.947zm-9.32-496.403c-80.024 0-145.128 65.104-145.128 145.128 0 80.024 65.104 145.128 145.128 145.128 80.024 0 145.128-65.104 145.128-145.128 0-80.024-65.104-145.128-145.128-145.128zm192.785-968.86h-385.57l93.901 851.327h197.768l93.901-851.327z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWarningLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconWarningLine, _Component);

  function IconWarningLine() {
    _classCallCheck(this, IconWarningLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconWarningLine).apply(this, arguments));
  }

  _createClass(IconWarningLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWarning",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWarningLine.displayName = "IconWarningLine";
  return IconWarningLine;
}(Component);

IconWarningLine.glyphName = 'warning';
IconWarningLine.variant = 'Line';
IconWarningLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWarningLine;
export { IconWarningLine };